export const defaultLocale = "en";
export const supportedLocales = ["en", "zh"];
